<template>
  <div id="modal-wrapper">
    <modal-component
      ref="modal"
      @onModalClose="onModalClose"
    >
      <div id="error-modal" class="modal-container">
        <div class="modal-header">
          <div class="text">{{ errorText ?? '' }}</div>
        </div>

        <div class="modal-controls">
          <base-button
            text="Ok"
            classes="def-btn main-action-btn uppercase medium border-2"
            @onClick="close"
          />
        </div>
      </div>
    </modal-component>
  </div>

</template>

<script>
import ModalComponent from "@/components/_shared/Modal";
import BaseButton from "@/components/_shared/Button.vue";

export default {
  name: 'ErrorModal',

  emits: ['onModalClose', 'cancelOrder'],

  components: {
    ModalComponent,
    BaseButton
  },

  data() {
    return {
      errorText: '',
    }
  },

  mounted() {
    this.emmiter.on('closeModal', () => {
      this.close();
    })
  },

  beforeUnmount() {
    this.emmiter.off('closeModal');
    this.emmiter.emit('toggleModals', { opened: false, type: 'ErrorModal' });
  },

  methods: {
    onModalClose() {
      this.$emit('onModalClose');
    },

    openModal(errorText) {
      this.errorText = errorText;

      this.emmiter.emit('toggleModals', { opened: true, type: 'ErrorModal' });
      this.$refs['modal'].show();
    },

    close() {
      this.errorText = '';
      this.$refs['modal'].close();
      this.emmiter.emit('toggleModals', { opened: false, type: 'ErrorModal' });
    },
  }
}
</script>

<style scoped lang="less">
#modal-wrapper {
  #error-modal {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height: 100%;

    .text {
      max-width: 400px;
    }

    .modal-controls {
      justify-content: center;

      button {
        min-width: 200px;
      }
    }
  }
}
</style>
